var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-card",
    [
      _c("template", { slot: "header" }, [
        _c("span", [_vm._v("Select Asset")]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "body" }, slot: "body" },
        [
          _c(
            "el-table",
            {
              staticStyle: { "margin-bottom": "0.24rem" },
              attrs: {
                stripe: "",
                data: _vm.tableList,
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "account", label: "Account" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(row.account))]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "type", label: "Type" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(
                            _vm._f("dictFilter")(
                              row.type,
                              _vm.$store.getters.accountTypes
                            )
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "assetForm",
              staticClass: "page-form point-form",
              attrs: { model: _vm.pageData, "label-position": "top" },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 40 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "asset",
                            label: "Please select your asset",
                            rules: [
                              {
                                required: true,
                                message: "Please select",
                                trigger: "change",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: { change: _vm.changeAsset },
                              model: {
                                value: _vm.pageData.asset,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pageData, "asset", $$v)
                                },
                                expression: "pageData.asset",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("Mineral"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.pageData.asset && _vm.pageData.asset.indexOf("1") > -1
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "region",
                                label: "Select region",
                                rules: [
                                  {
                                    required: true,
                                    message: "Please select",
                                    trigger: "change",
                                  },
                                ],
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "Please select…" },
                                  on: { change: _vm.changeRegion },
                                  model: {
                                    value: _vm.pageData.region,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.pageData, "region", $$v)
                                    },
                                    expression: "pageData.region",
                                  },
                                },
                                _vm._l(_vm.regionList, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.name,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }